import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class DocumentJpkMppIsNotObligatoryWarning extends Violation {
    public constructor() {
        super(ViolationSeverity.Warning, 'business.document.sale.validation.document-jpk-mpp-is-not-obligatory');
    }
}
